export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11575.175de8e5.jpg";